import { useCliDockHeight } from './cliSessionStore';

// A spacer rather than padding on the layout, so only this re-renders when the dock is dragged.
function CliDockSpacer() {
  const height = useCliDockHeight();

  if (!height) return null;
  return <div className="CliDockSpacer" style={{ height }} aria-hidden />;
}

export default CliDockSpacer;
